module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.completed),
      expression: "!completed"
    }]
  }, [_c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "equation"
  }, [(this.currentQ.a) ? _c('span', {
    staticClass: "a",
    attrs: {
      "id": "a"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.a)
    }
  }) : _vm._e(), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]) : (this.currentQ.a) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "b",
    attrs: {
      "id": "b"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.b)
    }
  }), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]), _vm._v(" "), _c('span', {
    staticClass: "ab",
    attrs: {
      "id": "ab"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.ab)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "concentrations"
  }, [(this.currentQ.conc_a) ? _c('span', {
    staticClass: "a",
    attrs: {
      "id": "conc_a"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.conc_a)
    }
  }) : _vm._e(), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]) : (this.currentQ.a) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "b",
    attrs: {
      "id": "conc_b"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.conc_b)
    }
  }), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]), _vm._v(" "), _c('span', {
    staticClass: "ab",
    attrs: {
      "id": "conc_ab"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.conc_ab)
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "k"
    }
  }, [_vm._v("K = "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.currentQ.k)
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeQuiz"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.guessed),
      expression: "!guessed"
    }]
  }, [_c('div', {
    staticClass: "guess",
    class: _vm.hinting ? 'hint' : ''
  }, [_c('div', {
    staticClass: "col-2-3"
  }, [_c('p', [_vm._v("Enter a digit between 1.0 and 9.9")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Q =")]), _vm._v(" "), _c('span', {
    class: _vm.hinting ? 'hint' : '',
    attrs: {
      "id": "hint"
    }
  }, [_c('span', {
    staticClass: "fraction",
    class: this.currentQ.abflip ? 'abflip' : ''
  }, [_c('span', {
    attrs: {
      "id": "hinttop"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.hintTop)
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "hintbot"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.hintBottom)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "equals"
  }, [_vm._v("=")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    staticClass: "num",
    class: _vm.errorAnswer ? 'error' : '',
    attrs: {
      "placeholder": "Type in your answer",
      "type": "number",
      "min": "1",
      "max": "9.9",
      "step": "0.1",
      "disabled": _vm.submitText == 'Continue' ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "click": function($event) {
        _vm.checkError('answer')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "times"
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('p', [_vm._v("Exponent")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "number"
  }, [_vm._v("10 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exponent),
      expression: "exponent"
    }],
    staticClass: "exp",
    class: _vm.errorExponent ? 'error' : '',
    attrs: {
      "placeholder": "Exponent",
      "type": "number",
      "min": "-9",
      "max": "9",
      "step": "1",
      "disabled": _vm.submitText == 'Continue' ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.exponent)
    },
    on: {
      "click": function($event) {
        _vm.checkError('exponent')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exponent = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitText == 'Continue'),
      expression: "submitText=='Continue'"
    }],
    staticClass: "submits"
  }, [_c('p', [_vm._v("Correct answer shown, you may continue.")])]), _vm._v(" "), _c('div', {
    staticClass: "submits"
  }, [_c('button', {
    staticClass: "btn submit",
    attrs: {
      "disabled": _vm.submitText == 'Try Again' ? 'disabled' : false
    },
    on: {
      "click": _vm.submitOne
    }
  }, [_vm._v(_vm._s(_vm.submitText))]), _vm._v(" "), _c('a', {
    staticClass: "btn alt",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showHint
    }
  }, [_vm._v("Show Hint")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeQuiz"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guessed),
      expression: "guessed"
    }]
  }, [_c('div', {
    staticClass: "guess guessed"
  }, [_c('div', [_c('span', [_vm._v("Q = ")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.answer))]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("10"), _c('sup', [_vm._v(_vm._s(_vm.exponent))])])])]), _vm._v(" "), _c('div', {
    staticClass: "guess-second",
    class: _vm.q2error ? 'q2error' : ''
  }, [_c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitText == 'Submit'),
      expression: "submitText=='Submit'"
    }],
    staticClass: "preq2"
  }, [_vm._v("Correct!")]), _vm._v(" Question 2: In which direction will equilibrium shift?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    attrs: {
      "type": "radio",
      "value": "left",
      "id": "left",
      "disabled": _vm.guessed2
    },
    domProps: {
      "checked": _vm._q(_vm.direction, "left")
    },
    on: {
      "change": function($event) {
        _vm.direction = "left"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.classLeft,
    attrs: {
      "for": "left"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("A")]), _vm._v(" "), (_vm.missed == 'left') ? _c('span', [_vm._v("\n              Since Q is greater than K there are initially too many products and too few reactants present. The reaction will shift left to produce more reactants until equilibrium is reached.\n            ")]) : _c('span', [_vm._v("Since Q is greater than K, equilibrium will shift left towards the reactants.")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    attrs: {
      "type": "radio",
      "value": "right",
      "id": "right",
      "disabled": _vm.guessed2
    },
    domProps: {
      "checked": _vm._q(_vm.direction, "right")
    },
    on: {
      "change": function($event) {
        _vm.direction = "right"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.classRight,
    attrs: {
      "for": "right"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("B")]), _vm._v(" "), (_vm.missed == 'right') ? _c('span', [_vm._v("\n              Since Q is less than K there are initially too many reactants and too few products present. The reaction will shift right to produce more products until equilibrium is reached.\n            ")]) : _c('span', [_vm._v("Since Q is less than K, equilibrium will shift right towards the products.")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    attrs: {
      "type": "radio",
      "value": "equal",
      "id": "equal",
      "disabled": _vm.guessed2
    },
    domProps: {
      "checked": _vm._q(_vm.direction, "equal")
    },
    on: {
      "change": function($event) {
        _vm.direction = "equal"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.classEqual,
    attrs: {
      "for": "equal"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("C")]), _vm._v(" "), (_vm.missed == 'equal') ? _c('span', [_vm._v("Since Q is equal to K there is an equal amount of reactants and products, the reaction is at equilibrium.")]) : _c('span', [_vm._v("Since Q is equal to K, the reaction is at equilibrium.")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.guessed2),
      expression: "!guessed2"
    }],
    staticClass: "submits"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submitTwo
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guessed2),
      expression: "guessed2"
    }],
    staticClass: "results"
  }, [_c('div', {
    staticClass: "col-1-3 right",
    class: this.currentQ.shift === 'right' ? '' : 'fade'
  }, [_c('p', [_vm._v("Too much reactant")]), _vm._v(" "), _c('div', {
    staticClass: "bars"
  }, [_c('div', {
    staticClass: "q",
    staticStyle: {
      "height": "30%"
    }
  }, [_c('span', [_vm._v("Q")])]), _vm._v(" "), _c('div', {
    staticClass: "k",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("K")])])]), _vm._v(" "), _c('p', [_vm._v("If Q < K"), _c('sub', [_vm._v("eq")]), _vm._v(", shift to right, toward product")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 equal",
    class: this.currentQ.shift === 'equal' ? '' : 'fade'
  }, [_c('p', [_vm._v("Equilibrium")]), _vm._v(" "), _c('div', {
    staticClass: "bars"
  }, [_c('div', {
    staticClass: "q",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("Q")])]), _vm._v(" "), _c('div', {
    staticClass: "k",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("K")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 left",
    class: this.currentQ.shift === 'left' ? '' : 'fade'
  }, [_c('p', [_vm._v("Too much product")]), _vm._v(" "), _c('div', {
    staticClass: "bars"
  }, [_c('div', {
    staticClass: "q",
    staticStyle: {
      "height": "90%"
    }
  }, [_c('span', [_vm._v("Q")])]), _vm._v(" "), _c('div', {
    staticClass: "k",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("K")])])]), _vm._v(" "), _c('p', [_vm._v("If Q > K"), _c('sub', [_vm._v("eq")]), _vm._v(", shift to left, toward reactant")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guessed2 && (_vm.alright || _vm.missed)),
      expression: "guessed2 && (alright||missed)"
    }],
    staticClass: "submits"
  }, [(_vm.alright) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("Correct! Next Question")]) : _vm._e(), _vm._v(" "), (_vm.missed) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("Next Question")]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.completed),
      expression: "completed"
    }],
    staticClass: "completed"
  }, [_c('div', {
    staticClass: "question"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "concentrations"
  }, [_c('span', [_vm._v("You got " + _vm._s(_vm.correct) + " out of " + _vm._s(this.questions.length) + "!")])]), _vm._v(" "), _c('div', {
    staticClass: "submits"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.resetEverything
    }
  }, [_vm._v("Restart Quiz")])])])]), _vm._v(" "), (_vm.debug) ? _c('div', {
    staticClass: "debug"
  }, [_vm._v("\n    debug:"), _c('br'), _vm._v("\n    #" + _vm._s(this.currentCount + 1) + " out of " + _vm._s(this.questions.length) + ", score: " + _vm._s(_vm.correct)), _c('br'), _vm._v("\n    Q = " + _vm._s(this.currentQ.answer) + " × 10"), _c('sup', [_vm._v(_vm._s(this.currentQ.exponent))]), _c('br'), _vm._v("\n    shift: " + _vm._s(this.currentQ.shift) + "\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Predicting Shifts In Equilibrium: "), _c('span', [_vm._v("Q")]), _vm._v(" vs "), _c('span', [_vm._v("K")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "equation"
  }, [_c('span', [_vm._v("Quiz complete!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0459d559","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quiz.vue
// module id = 13
// module chunks = 1